import type { ComponentType, JSX } from 'react';

import { AirdropDetailsPage } from '@/pages/AirdropDetailsPage/AirdropDetailsPage';
import { BattleChooseMovePage } from '@/pages/BattleChooseMovePage/BattleChooseMovePage';
import { BattleLeaderboardPage } from '@/pages/BattleLeaderboardPage/BattleLeaderboardPage';
import { BattleLevelUpPage } from '@/pages/BattleLevelUpPage/BattleLevelUpPage';
import { BattlePage } from '@/pages/BattlePage/BattlePage';
import { BattleStatsPage } from '@/pages/BattleStatsPage/BattleStatsPage';
import { IndexPage } from '@/pages/DebugPage/IndexPage';
import { FeedToEarnPage } from '@/pages/FeedToEarnPage/FeedToEarnPage';
import { HomePage } from '@/pages/HomePage/HomePage';
import { InitDataPage } from '@/pages/InitDataPage/InitDataPage';
import { LandingPage } from '@/pages/LandingPage/LandingPage';
import { LaunchParamsPage } from '@/pages/LaunchParamsPage/LaunchParamsPage.tsx';
import { SpinnerPage } from '@/pages/SpinnerPage/SpinnerPage';
import { TONConnectPage } from '@/pages/TONConnectPage/TONConnectPage';
import { ThemeParamsPage } from '@/pages/ThemeParamsPage/ThemeParamsPage.tsx';
import { EarnPage } from '@/pages/EarnPage/EarnPage';
import { ShopPage } from '@/pages/ShopPage/ShopPage';
import { ClaimRewardsPage } from '@/pages/ClaimRewardsPage/ClaimRewardsPage';
import { InvitePage } from '@/pages/InvitePage/InvitePage';

interface Route {
  path: string;
  Component: ComponentType;
  title?: string;
  icon?: JSX.Element;
}

export const routes: Route[] = [
  { path: '/', Component: LandingPage },
  { path: '/home', Component: HomePage },
  { path: '/init-data', Component: InitDataPage, title: 'Init Data' },
  { path: '/theme-params', Component: ThemeParamsPage, title: 'Theme Params' },
  {
    path: '/launch-params',
    Component: LaunchParamsPage,
    title: 'Launch Params',
  },
  {
    path: '/debug',
    Component: IndexPage,
    title: 'Debug',
  },
  {
    path: '/battle-level-up',
    Component: BattleLevelUpPage,
    title: 'Level Up',
  },
  {
    path: '/battle-stats',
    Component: BattleStatsPage,
    title: 'Stats Page',
  },
  {
    path: '/battle-choose-move',
    Component: BattleChooseMovePage,
    title: 'Choose Move',
  },
  {
    path: '/battle/:id',
    Component: BattlePage,
    title: 'Battle',
  },
  {
    path: '/spinner',
    Component: SpinnerPage,
    title: 'Spinner',
  },
  {
    path: '/shop',
    Component: ShopPage,
    title: 'Shop',
  },
  {
    path: '/feed-to-earn',
    Component: FeedToEarnPage,
    title: 'Feed to earn',
  },
  {
    path: '/claim-rewards',
    Component: ClaimRewardsPage,
    title: 'Claim Rewards',
  },
  {
    path: '/battle-leaderboard',
    Component: BattleLeaderboardPage,
    title: 'Leaderboard',
  },
  {
    path: '/invite',
    Component: InvitePage,
    title: 'Invite',
  },
  {
    path: '/airdrop-detail-page',
    Component: AirdropDetailsPage,
    title: 'Airdrop Detail Page',
  },
  {
    path: '/earn',
    Component: EarnPage,
    title: 'Earn',
  },
  {
    path: '/ton-connect',
    Component: TONConnectPage,
    title: 'TON Connect',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 56 56"
        fill="none"
      >
        <path
          d="M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z"
          fill="#0098EA"
        />
        <path
          d="M37.5603 15.6277H18.4386C14.9228 15.6277 12.6944 19.4202 14.4632 22.4861L26.2644 42.9409C27.0345 44.2765 28.9644 44.2765 29.7345 42.9409L41.5381 22.4861C43.3045 19.4251 41.0761 15.6277 37.5627 15.6277H37.5603ZM26.2548 36.8068L23.6847 31.8327L17.4833 20.7414C17.0742 20.0315 17.5795 19.1218 18.4362 19.1218H26.2524V36.8092L26.2548 36.8068ZM38.5108 20.739L32.3118 31.8351L29.7417 36.8068V19.1194H37.5579C38.4146 19.1194 38.9199 20.0291 38.5108 20.739Z"
          fill="white"
        />
      </svg>
    ),
  },
];
